import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateMediaplansMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  new: ReadonlyArray<Types.AccountsMediaplanCreateInput> | Types.AccountsMediaplanCreateInput;
  updated: ReadonlyArray<Types.AccountsMediaplanUpdateInput> | Types.AccountsMediaplanUpdateInput;
  removed: ReadonlyArray<Types.AccountsMediaplanRemoveInput> | Types.AccountsMediaplanRemoveInput;
}>;


export type UpdateMediaplansMutationPage = { readonly __typename?: 'RootMutationType', readonly updateMediaplans: boolean };

export type SaveKpiSettingsMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  settings: Types.YalperKpiSettingsInput;
}>;


export type SaveKpiSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveKpiSettings: boolean };


export const UpdateMediaplansDocument = gql`
    mutation UpdateMediaplans($id: ID!, $new: [AccountsMediaplanCreateInput!]!, $updated: [AccountsMediaplanUpdateInput!]!, $removed: [AccountsMediaplanRemoveInput!]!) {
  updateMediaplans(id: $id, new: $new, updated: $updated, removed: $removed)
}
    `;
export type UpdateMediaplansMutationFn = Apollo.MutationFunction<UpdateMediaplansMutationPage, UpdateMediaplansMutationVariables>;

/**
 * __useUpdateMediaplansMutation__
 *
 * To run a mutation, you first call `useUpdateMediaplansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaplansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaplansMutation, { data, loading, error }] = useUpdateMediaplansMutation({
 *   variables: {
 *      id: // value for 'id'
 *      new: // value for 'new'
 *      updated: // value for 'updated'
 *      removed: // value for 'removed'
 *   },
 * });
 */
export function useUpdateMediaplansMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaplansMutationPage, UpdateMediaplansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaplansMutationPage, UpdateMediaplansMutationVariables>(UpdateMediaplansDocument, options);
      }
export type UpdateMediaplansMutationHookResult = ReturnType<typeof useUpdateMediaplansMutation>;
export type UpdateMediaplansMutationResult = Apollo.MutationResult<UpdateMediaplansMutationPage>;
export type UpdateMediaplansMutationOptions = Apollo.BaseMutationOptions<UpdateMediaplansMutationPage, UpdateMediaplansMutationVariables>;
export const SaveKpiSettingsDocument = gql`
    mutation SaveKpiSettings($companyId: ID!, $settings: YalperKpiSettingsInput!) {
  saveKpiSettings(companyId: $companyId, settings: $settings)
}
    `;
export type SaveKpiSettingsMutationFn = Apollo.MutationFunction<SaveKpiSettingsMutationPage, SaveKpiSettingsMutationVariables>;

/**
 * __useSaveKpiSettingsMutation__
 *
 * To run a mutation, you first call `useSaveKpiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveKpiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveKpiSettingsMutation, { data, loading, error }] = useSaveKpiSettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveKpiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveKpiSettingsMutationPage, SaveKpiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveKpiSettingsMutationPage, SaveKpiSettingsMutationVariables>(SaveKpiSettingsDocument, options);
      }
export type SaveKpiSettingsMutationHookResult = ReturnType<typeof useSaveKpiSettingsMutation>;
export type SaveKpiSettingsMutationResult = Apollo.MutationResult<SaveKpiSettingsMutationPage>;
export type SaveKpiSettingsMutationOptions = Apollo.BaseMutationOptions<SaveKpiSettingsMutationPage, SaveKpiSettingsMutationVariables>;